
// You can write more code here

/* START OF COMPILED CODE */

import BaseButton from "../BaseButton";
import UIButton from "../components/UIButton";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class BtnReplayEnd extends BaseButton {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 80.5, y ?? 80.5);

    // btn_endscreen_png
    const btn_endscreen_png = scene.add.image(0, 0, "common", "btn-replay-screen.png");
    this.add(btn_endscreen_png);

    // icon_replay_png
    const icon_replay_png = scene.add.image(0, 0, "common", "icon-replay.png");
    icon_replay_png.visible = false;
    this.add(icon_replay_png);

    // this (components)
    new UIButton(this);

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
